import React from 'react'
import { Route } from 'react-router-dom'
import ReportContent from './ReportContent'
import { ReportSection } from '../types'
import CustomSwitch from '../../router/CustomSwitch'
import TransactionDrilldown from './insights/TransactionDrilldown'
import { getFlatSubReportSections } from '../utils/sections'

type Props = {
  route: string
  reportSection: ReportSection
  report: any
}

const reportDetailsRegex = /(?:balance-sheet-variance|profit-and-loss-variance)\/details$/

export default function ReportSectionComponent(props: Props) {
  const { route, reportSection, report } = props

  return (
    <CustomSwitch>
      <Route exact path={route}>
        {reportDetailsRegex.test(route) ? (
          <TransactionDrilldown report={report} reportSection={reportSection} />
        ) : (
          <ReportContent report={report} reportSection={reportSection} />
        )}
      </Route>
      {getFlatSubReportSections(reportSection).map((subSection) => {
        const subRoute = `${route}/${subSection.route}`

        return (
          <Route path={subRoute} key={subSection.label}>
            <ReportSectionComponent
              route={subRoute}
              reportSection={{ ...subSection, parentSection: reportSection }}
              report={report}
            />
          </Route>
        )
      })}
    </CustomSwitch>
  )
}
